<template lang="pug">
  section.main(:class="collapsed ? 'wide' : 'narrow'")
    Header(ref="header")
    Menu
    section.page.route(v-if="$auth.isAuthenticated && currentUser")
      b-navbar.title
        b-navbar-brand
          i.icon.fas.fa-route
          span {{ page.title }}
        b-navbar-nav.ml-auto
          b-nav-item
            b-button(variant="link",@click="onClose()") 一覧へ戻る

      section.body(ref="body")
        ValidationObserver(slim,ref="observer")
          b-form.form(ref="form",:data-mode="mode",@submit.prevent)
            b-container(fluid)
              b-row.pt-3
                b-col(cols=6)
                  b-form-group(label="種別",label-for="input-category",description="",required)
                    ValidationProvider(rules="required",name="種別",v-slot="{ errors }")
                      b-form-select#input-category(v-model="datum.category",:options="options.category",required,placeholder="種別を選択してください",@change="validateInput",:disabled="!editable || mode !== 'add'",:readonly="!editable || mode !== 'add'")
                      .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                b-col(cols=6)
              b-row
                b-col
                  b-form-group(:label="!datum.category || datum.category === 'other' ? 'その他の採用ルート名' : datum.category === 'agent' ? '会社名' : datum.category === 'media' ? 'メディア名（求人サイト名）' : datum.category === 'referrer' ? '社員名（紹介者名）' : datum.category === 'direct' ? '直接応募ルート名' : '(不明または未対応の採用ルート名)'",label-for="input-name",description="",required)
                    ValidationProvider(rules="required|max:100",:name="!datum.category || datum.category === 'other' ? '採用ルート名' : datum.category === 'agent' ? '会社名' : datum.category === 'media' ? 'メディア名' : datum.category === 'referrer' ? '社員名' : datum.category === 'direct' ? '応募ルート名' : '-'",v-slot="{ errors }")
                      b-form-input#input-name(ref="input-name",v-model="datum.name",type="text",required,:placeholder="(!datum.category || datum.category === 'other' ? '採用ルート名' : datum.category === 'agent' ? '会社名' : datum.category === 'media' ? 'メディア名' : datum.category === 'referrer' ? '社員名' : datum.category === 'direct' ? '応募ルート名' : '-') + 'を入力してください'",@input="validateInput",:disabled="!editable",:readonly="!editable")
                      .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
              b-row
                b-col
                  b-form-group(v-if="datum.category && (datum.category === 'agent' || datum.category === 'media')",:label="datum.category === 'agent' ? '会社URL' : datum.category === 'media' ? 'ログインURL' : '-'",label-for="input-url",description="")
                    ValidationProvider(:rules="{ regex: /^https?:\\/\\/[-a-zA-Z0-9@:%._\\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*)$/, max: 200 }",name="URL",v-slot="{ errors }")
                      b-form-input#input-url(ref="input-url",v-model="datum.url",type="url",placeholder="URLを入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                      .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
              b-row
                b-col
                  b-form-group(v-if="datum.category && datum.category === 'agent'",label="担当者名",label-for="input-person",description="")
                    ValidationProvider(rules="max:100",name="担当者名",v-slot="{ errors }")
                      b-form-input#input-person(ref="input-person",v-model="datum.person",type="text",placeholder="担当者名を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                      .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
              b-row
                b-col
                  b-form-group(v-if="datum.category && datum.category === 'referrer'",label="部署名",label-for="input-department",description="")
                    ValidationProvider(rules="max:100",name="部署名",v-slot="{ errors }")
                      b-form-input#input-department(ref="input-department",v-model="datum.department",type="text",placeholder="部署名を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                      .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
              b-row
                b-col
                  b-form-group(v-if="datum.category && (datum.category === 'agent' || datum.category === 'referrer')",label="メールアドレス",label-for="input-email",description="")
                    ValidationProvider(rules="email:max:120",name="メールアドレス",v-slot="{ errors }")
                      b-form-input#input-email(ref="input-email",v-model="datum.email",type="email",placeholder="メールアドレスを入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                      .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
              b-row
                b-col
                  b-form-group(label="エージェント",label-for="input-agents",description="")
                    ValidationProvider(rules="",name="エージェント",v-slot="{ errors }")
                      v-select#input-agents(ref="agents",v-model="selected.agents",multiple,:filterable="false",:options="options.agent",label="name",placeholder="エージェントを指定してください",@input="validateInput",@search="onAgentSearch", :disabled="!editable",:readonly="!editable")
                        template(slot="no-options")
                          span type name to search Users...
                        template(slot="option",slot-scope="option")
                          .d-center
                            span {{ `${option && option.name ? option.name : ''}` }}
                        template(slot="selected-option",slot-scope="option")
                          .d-center.selected
                            span {{ `${option && option.name ? option.name : ''}` }}
                      .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
              b-row
                b-col
                  b-form-group(label="採用コンサルタント",label-for="input-consultants",description="")
                    ValidationProvider(rules="",name="採用コンサルタント",v-slot="{ errors }")
                      v-select#input-consultants(ref="consultants",v-model="selected.consultants",multiple,:filterable="false",:options="options.consultant",label="name",placeholder="採用コンサルタントを指定してください",@input="validateInput",@search="onConsultantSearch", :disabled="!editable",:readonly="!editable")
                        template(slot="no-options")
                          span type name to search Users...
                        template(slot="option",slot-scope="option")
                          .d-center
                            span {{ `${option && option.name ? option.name : ''}` }}
                        template(slot="selected-option",slot-scope="option")
                          .d-center.selected
                            span {{ `${option && option.name ? option.name : ''}` }}
                      .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
              b-row
                b-col
                  b-form-group(label="備考",label-for="input-note",description="")
                    ValidationProvider(rules="max:4000",name="備考",v-slot="{ errors }")
                      b-form-textarea#input-note(v-model="datum.note",type="text",max-rows="20",placeholder="備考",@input="validateInput",:disabled="!editable",:readonly="!editable")
                      .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
              b-row(v-if="datum.name === 'ビズリーチ' || datum.name === 'Wantedly' || datum.name === 'Green'" )
                b-col
                  b-button.mr-3(variant="primary",v-b-modal.modal-edit)
                    span.ml-1 候補者情報を取り込む
        b-modal#modal-edit(size="lg", hide-header, @show="initModal()")
          ValidationObserver(slim,ref="observerCrawl")
            b-form.text-left(@submit.prevent)
              b-container(fluid)
                b-row
                  b-col
                    b-form-group(label="ログインID",label-for="input-firstName",description="",required)
                      ValidationProvider(:rules="{ required: true, }",name="ログインID",v-slot="{ errors }")
                        b-form-input#input-number(v-model="loginId",type="text",autocomplete="login",placeholder="ログインIDを入力",@input="validateInputCrawl")
                        .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                b-row
                  b-col
                    b-form-group#input-names(label="パスワード",label-for="input-firstName",description="",required)
                      .form-inline
                        ValidationProvider#firstName(rules="required",name="パスワード",v-slot="{ errors }")
                          b-form-input#input-password(v-model="password",type="password",autocomplete="password",placeholder="パスワードを入力",@input="validateInputCrawl")
                          .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                b-row
                  b-col
                    b-form-group(label="エントリー日（以下で設定した日付から現在までにエントリーした候補者情報を取り込みます）",label-for="input-firstName",description="",required)
                      b-form-datepicker(id="applicate-datepicker",v-model="applicate",required)
                b-row(v-if="datum.name === 'ビズリーチ'" )
                  b-col
                    b-form-group(label="リクルーターアカウント",label-for="input-firstName",description="")
                      ValidationProvider(name="リクルーターアカウント",v-slot="{ errors }")
                        b-form-input#input-number(v-model="recruiter",type="text",placeholder="リクルーター名を入力",@input="validateInputCrawl")
                        .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
            b-spinner(v-show="isProgress")
          template(v-slot:modal-footer="{ ok, cancel }")
            b-button(variant="secondary",@click="$bvModal.hide('modal-edit')") キャンセル
            b-button(variant="primary",@click="doCrawl(datum.name)",:disabled="!validCrawl")
              span 取得する
          template(v-for="text in crawlMessage")
            p.text-danger(v-text="text")
          table.add-table(v-if="crawlBox.length > 0")
            tr
              th 氏名
              th 応募日
              th 経由
              th 採用ルート
              th 応募ポジション
              th 登録ポジション
              th 実行
            template(v-for="item in crawlBox")
              tr
                td
                  p(v-text="item['lastName']+' '+item['firstName']")
                td
                  p(v-text="item['appliedAt']")
                td
                  p(v-text="item['via']")
                td
                  b-form-select#input-job(v-model="item['routeId']",:options="options.route")
                td
                  p(v-text="item['position']")
                td
                  b-form-select#input-job(v-model="item['jobId']",:options="options.job")
                td
                  b-button(variant="primary",@click="doCrawlSave(item)")
                    span 保存する
        b-navbar.border-top.bottom-nav.bg-secondary
          b-navbar-nav
            b-nav-item
              b-button(variant="primary",v-show="mode === 'add' || mode === 'edit'",@click="onSave()",:disabled="!valid || !changed")
                span 保存
          b-navbar-nav.ml-auto
            b-nav-item
              b-button.mx-2(v-if="currentUser && currentUser.acl && currentUser.acl.routes && currentUser.acl.routes.delete",variant="outline-danger",@click="onDelete()",:disabled="!currentUser.acl || !currentUser.acl.routes || !currentUser.acl.routes.delete")
                span 削除
</template>

<script>
import { cloneDeep, isEqual } from 'lodash'

import QueryHash from 'query-hash'

import { getData, postData, patchData, deleteData } from '../utils/api'

import { clone, difference, optionsCategory } from '../utils/libs'

const page = {
  id: 'route',
  title: '採用ルート情報'
}

export default {
  // props: ['mode'],
  data () {
    return {
      isProgress: false,
      mask: false,
      page: page,
      collapsed: true,
      currentUser: null,
      mode: null,
      editable: null,
      changed: false,
      valid: false,
      loginId: '',
      password: '',
      applicate: '',
      recruiter: '',
      datum: {},
      recentDatum: {},
      options: {
        category: [],
        agent: [],
        consultant: [],
        job: [],
        route: [],
        peoples: []
      },
      selected: {
        agents: {},
        consultants: {}
      },
      validCrawl: false,
      crawlMessage: [],
      crawlBox: []
    }
  },
  async mounted () {
    this.mode = 'add'
    this.editable = true
    if (this.$route.params.id) {
      this.id = this.$route.params.id
      this.mode = 'show'
      this.editable = false
    }

    this.options.category = optionsCategory()
    this.options.category.unshift({
      value: null, text: '種別を選択してください' //, disabled: true
    })
    this.options.job = []
    await getData(`/jobs?sort=occupation,position&limit=-1`).then((data) => {
      for (let datum of data) {
        this.options.job.push({
          value: datum._id, text: datum.name
        })
      }
    }).catch((err) => {
      console.log(err)
    })
    this.options.route = []
    await getData(`/routes?sort=postedAt&limit=-1`).then((data) => {
      for (let datum of data) {
        this.options.route.push({
          value: datum._id, text: datum.name
        })
      }
    }).catch((err) => {
      console.log(err)
    })

    this.options.peoples = []
    await getData(`/peoples`).then(async (data) => {
      if (data && data.length > 0) {
        this.options.peoples = cloneDeep(data)
      }
    }).catch((err) => {
      console.log(err)
    })

    this.changeMode()
  },
  methods: {
    async validateInput () {
      await this.$refs.observer.reset()
      this.valid = await this.$refs.observer.validate()

      if (this.valid) {
        /*
        if (this.selected.agents.length < 1) {
          this.valid = false
        }

        if (this.selected.consultants.length < 1) {
          this.valid = false
        }
        */
      }

      let currentDatum = clone(this.datum)
      currentDatum.agents = clone(this.selected.agents)
      currentDatum.consultants = clone(this.selected.consultants)

      const diffDatum = difference(currentDatum, this.recentDatum)
      if (!isEqual({}, diffDatum)) {
        this.changed = true
        if (diffDatum.category) {
          this.$forceUpdate()
          this.validateInput()
        }
      }

      this.recentDatum = clone(this.datum)
      this.recentDatum.agents = clone(this.selected.agents)
      this.recentDatum.consultants = clone(this.selected.consultants)
    },
    changeMode () {
      if (this.mode === 'add' || this.mode === 'edit') {
        this.editable = true
      } else {
        this.editable = false
      }
      this.loadData()
    },
    async loadData () {
      this.mask = true

      if (!this.$root.currentUser || !this.$root.currentUser.role) {
        setTimeout(() => {
          this.loadData()
        }, 300)
        return
      }
      this.$set(this, 'currentUser', this.$root.currentUser)

      let message = null

      this.datum = {}
      this.recentDatum = {}

      this.options.agent = []
      this.selected.agents = []
      this.options.consultant = []
      this.selected.consultants = []

      await getData(`/users?filter={role:{$in:["agent"]}}&fields=_id,name`).then((data) => {
        this.options.agent = data
      })
      await getData(`/users?filter={role:{$in:["consultant"]}}&fields=_id,name`).then((data) => {
        this.options.consultant = data
      })

      this.$refs.agents.search = ''
      this.$refs.consultants.search = ''

      if (this.mode === 'add') {
        if (!this.currentUser.acl || !this.currentUser.acl.routes || !this.currentUser.acl.routes.post) {
          this.handleLink(`/${this.$route.params.directory}/routes`)
        }

        if (this.options.category.length > 1) {
          this.datum.category = this.options.category[1].value
        }

        this.recentDatum = clone(this.datum)

        this.changed = false

        this.$nextTick(() => {
          this.$refs.observer.reset()
        })
      } else if (this.$route.params.id) {
        if (!this.currentUser.acl || !this.currentUser.acl.routes || !this.currentUser.acl.routes.get) {
          this.handleLink(`/${this.$route.params.directory}/routes`)
        }

        if (this.currentUser.acl && this.currentUser.acl.routes && this.currentUser.acl.routes.patch) {
          this.editable = true
          this.mode = 'edit'
        }

        await getData(`/routes/${this.$route.params.id}`).then((datum) => {
          if (datum) {
            this.datum = clone(datum)

            if (this.datum.Agents) {
              this.selected.agents = clone(this.datum.Agents)
              // this.options.agent = this.selected.agents
              delete this.datum.Agents
            }

            if (this.datum.Consultants) {
              this.selected.consultants = clone(this.datum.Consultants)
              // this.options.consultant = this.selected.consultants
              delete this.datum.Consultants
            }

            this.validateInput()

            this.recentDatum = clone(this.datum)
            this.recentDatum.agents = clone(this.selected.agents)
            this.recentDatum.consultants = clone(this.selected.consultants)

            this.changed = false
            this.valid = false
          } else {
            message = 'Not Found Data'
          }
        }).catch((err) => {
          console.log(err)

          message = 'データの読込に失敗しました'

          if (err.response.data) {
            if (err.response.data.code && err.response.data.message) {
              message = err.response.data.message
            } else if (err.response.data.message) {
              message = err.response.data.message
            }
          }
        })
      }

      this.mask = false

      if (message) {
        this.msgBoxError(message)
        this.handleLink(`/${this.$route.params.directory}/routes`)
      }

      this.$forceUpdate()

      this.$nextTick(() => {
        this.$refs.observer.reset()
      })
    },
    onAgentSearch (search, loading) {
      this.onOptionSearch('agent', search, loading)
    },
    onConsultantSearch (search, loading) {
      this.onOptionSearch('consultant', search, loading)
    },
    async onOptionSearch (field, search, loading) {
      const that = this
      loading(true)

      let roles
      let selectedUsers

      if (field === 'agent') {
        roles = ['agent']
        selectedUsers = clone(this.selected.agents)
      } else if (field === 'consultant') {
        roles = ['consultant']
        selectedUsers = clone(this.selected.consultants)
      }

      let query = new QueryHash()
      let filters = []
      if (search) {
        filters.push({
          $or: [
            { name: `RegExp:('${search}')` },
            { email: `RegExp:('${search}')` }
          ]
        })
      }
      filters.push({
        role: {
          $in: roles
        }
      })

      let selectedIds = []

      if (selectedUsers && selectedUsers.length > 0) {
        selectedUsers.forEach((selectedUser) => {
          selectedIds.push(`ObjectId:('${selectedUser._id}')`)
        })
        if (selectedIds.length > 0) {
          filters.push({ _id: { $nin: selectedIds } })
        }
      }

      query.add('filter', JSON.stringify({ $and: filters }))

      query.add('fields', '_id,name')

      await getData(`/users?${query.toQueryString()}`).then((data) => {
        that.$data.options[field] = data
        loading(false)
      })
    },
    onClose () {
      if (this.mode === 'show') {
        this.doClose()
      } else if (this.mode === 'edit') {
        if (!this.changed) {
          this.doClose()
        } else {
          this.msgBoxConfirm('内容が変更されています。変更を破棄しますか？', () => {
            this.doClose()
          })
        }
      } else if (this.mode === 'add') {
        if (!this.changed) {
          this.doClose()
        } else {
          this.msgBoxConfirm('内容が変更されています。変更を破棄しますか？', () => {
            this.doClose()
          })
        }
      }
    },
    doClose () {
      this.handleLink(`/${this.$route.params.directory}/routes`)
    },
    async onSave () {
      this.valid = await this.$refs.observer.validate()
      if (!this.valid) {
        this.msgBoxError('Invalid Inputs')
      } else {
        this.msgBoxConfirm('採用ルート情報を保存しますか？', this.doSave)
      }
    },
    async doSave () {
      this.mask = true

      let datum = clone(this.datum)
      delete datum.Agents
      datum.agents = []
      if (this.selected.agents && this.selected.agents.length > 0) {
        this.selected.agents.forEach((agent) => {
          datum.agents.push(agent._id)
        })
      }
      delete datum.Consultants
      datum.consultants = []
      if (this.selected.consultants && this.selected.consultants.length > 0) {
        this.selected.consultants.forEach((consultant) => {
          datum.consultants.push(consultant._id)
        })
      }

      delete datum.postedAt
      delete datum.PostedBy
      delete datum.patchedAt
      delete datum.PatchedBy

      let message = null

      if (this.mode === 'add') {
        await postData(`/routes/`, datum).then(async (json) => {
          // this.datum._id = json._id
          this.handleLink(`/${this.$route.params.directory}/routes`)
        }).catch((err) => {
          console.log(err)

          message = 'データの保存に失敗しました'

          if (err.response.data) {
            if (err.response.data.code && err.response.data.message) {
              message = err.response.data.message
            } else if (err.response.data.message) {
              message = err.response.data.message
            }
          }
        })
      } else {
        await patchData(`/routes/${datum._id}`, datum).then(async (json) => {
          this.handleLink(`/${this.$route.params.directory}/routes`)
        }).catch((err) => {
          console.log(err)

          message = 'データの保存に失敗しました'

          if (err.response.data) {
            if (err.response.data.code && err.response.data.message) {
              message = err.response.data.message
            } else if (err.response.data.message) {
              message = err.response.data.message
            }
          }
        })
      }

      this.mask = false

      if (message) {
        this.msgBoxError(message)
      }
    },
    onDelete () {
      if (!this.currentUser.acl || !this.currentUser.acl.routes || !this.currentUser.acl.routes.delete) {
        return
      }

      this.msgBoxConfirm('採用ルート情報を削除しますか？', this.doDelete)
    },
    async doDelete () {
      this.mask = true

      let message = ''

      await deleteData(`/routes/${this.datum._id}`).then((json) => {
        this.handleLink(`/${this.$route.params.directory}/routes`)
      }).catch((err) => {
        console.log(err)

        message = 'データの削除に失敗しました'

        if (err.response.data) {
          if (err.response.data.code && err.response.data.message) {
            message = err.response.data.message
          } else if (err.response.data.message) {
            message = err.response.data.message
          }
        }
      })

      this.mask = false

      if (message) {
        this.msgBoxError(message)
      }
    },

    initModal () {
      let objDate = new Date()
      objDate.setDate(objDate.getDate() - 1)
      let year = objDate.getFullYear()
      let month = objDate.getMonth() + 1
      let day = objDate.getDate()
      this.applicate = year + '-' + month + '-' + day
    },
    async validateInputCrawl () {
      await this.$refs.observerCrawl.reset()
      this.validCrawl = await this.$refs.observerCrawl.validate()
    },
    async onCrawl () {
      this.msgBoxConfirm('採用サイトの候補者を取得しますか？', this.doCrawl)
    },
    async doCrawl (name) {
      this.validCrawl = false
      this.isProgress = true
      this.crawlBox.splice(0)
      this.crawlMessage = []
      let crawlUrl = '/crawl'
      if (name === 'Green') {
        crawlUrl += '/green'
      } else if (name === 'Wantedly') {
        crawlUrl += '/wantedly'
      }
      await postData(`${crawlUrl}`, {
        login_id: this.loginId,
        password: this.password,
        date: this.applicate
      })
        .then((data) => {
          if (data.error) {
            this.crawlMessage.push(data.error)
            this.isProgress = false
            this.validCrawl = true
          } else {
            this.postPeopleData(data, 0)
          }
        }).catch((err) => {
          if (err.response && err.response.data) {
            if (err.response.data.message === 'Unregistered Company') {
              alert('Incorrect Directory')
              window.location.href = process.env.VUE_APP_PORTAL_URL
            } else if (err.response.data.error === 'Unauthorized') {
              alert(err.response.data.message)
            } else {
              alert('Internal Server Error')
            }
          }
          console.log('err:', err)
          this.isProgress = false
          this.validCrawl = true
        })
    },
    doCrawlSave (people) {
      // 重複チェック
      const duplicatedList = this.options.peoples.filter(registed => {
        return registed.firstName === people['firstName'] && registed.lastName === people['lastName'] && registed.appliedAt === people['appliedAt']
      })
      if (duplicatedList.length > 0) {
        this.crawlMessage.push(people['lastName'] + people['firstName'] + 'さんは重複していたため登録できません。')
      } else {
        postData(`/peoples/`, people).then(async (json) => {
          this.crawlMessage.push(people['lastName'] + people['firstName'] + 'さんが追加されました。')
          this.crawlBox = this.crawlBox.filter((item) => {
            return !(item['lastName'] === people['lastName'] && item['firstName'] === people['firstName'] && item['appliedAt'] === people['appliedAt'] && item['position'] === people['position'])
          })
        }).catch((err) => {
          console.log(err)
          this.crawlMessage.push(people['lastName'] + people['firstName'] + 'さんの追加に失敗しました。')
        })
      }
    },
    postPeopleData (list, num) {
      this.isProgress = false
      this.validCrawl = true
      for (let i = 0; i < list.length; i++) {
        let item = list[i]
        var date1 = new Date(this.applicate)
        var date2 = new Date(item.date.replace(/\//g, '-'))
        if (date2 < date1) {
          continue
        }
        let people = {
          lastName: item.name.split(' ')[0],
          firstName: item.name.split(' ')[1],
          appliedAt: item.date.replace(/\//g, '-'),
          via: item.via,
          position: item.position,
          route: this.datum.name,
          careers: [],
          links: [],
          educations: [],
          prefecture: null,
          note: ''
        }
        if (item.email) {
          people['email'] = item.email
        }
        if (item.birthday) {
          people['birthday'] = item.birthday.replace(/\//g, '-')
        }
        if (item.url) {
          people['links'].push({
            caption: 'レジュメ',
            url: item.url
          })
        }

        if (item.school) {
          let schoolSplit = item.school.split('卒 / ')
          if (schoolSplit.length > 1) {
            let schoolType = schoolSplit[0]
            let schoolTypeNum = '90'
            let schoolTypeEnum = {
              '大学院': '10',
              '大学': '20',
              '専門学校': '30',
              '高専': '40',
              '高校': '50'
            }
            if (schoolTypeEnum[schoolType] !== undefined) {
              schoolTypeNum = schoolTypeEnum[schoolType]
            }
            let schoolName = schoolSplit[1]
            people['educations'].push({
              schoolName: schoolName,
              qualification: schoolTypeNum,
              enrolledAt: '',
              graduatedAt: ''
            })
          }
        }

        if (item.beforeJob) {
          let beforeJobSplit = item.beforeJob.split(' / ')
          if (beforeJobSplit.length > 1) {
            let beforeJobSplitName = beforeJobSplit[0]
            people['careers'].push({
              companyName: beforeJobSplitName,
              type: '90',
              retiredAt: '',
              joinedAt: ''
            })
          }
        }
        if (item.mobile) {
          people['mobile'] = item.mobile
        }
        if (item.prefecture) {
          people['prefecture'] = item.prefecture
        }
        if (item.salary) {
          people['salary'] = item.salary
        }
        if (item.gender) {
          people['gender'] = item.gender === '男性' ? '1' : '2'
        }
        if (item.note) {
          people['note'] = item.note
        }
        this.crawlBox.push(people)
      }
      if (!this.crawlBox.length) {
        this.crawlMessage.push('新規の候補者は0名でした。')
      }
    }
  }
}
</script>

<style scoped lang="stylus">
.body
  .form
    overflow-y scroll
    overflow-x hidden
    // min-height calc(100vh - 3.75rem - 5.5rem - 4.75rem - 1rem)
    height calc(100vh - 3.75rem - 5.5rem - 4.75rem)
.add-table
  width 100%
</style>
